(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  onReady(() => {
    const mobileNavigation = document.querySelector('.mobile-bottom-navigation');
    const purchaseBar = document.querySelector('[data-mobile-purchase-bar]');
    const overlaySelectors = [
      '.drawer',
      '.menu-drawer-container',
      '.header__search details',
      '.mobile-facets__disclosure',
    ];
    const overlayElements = overlaySelectors.flatMap((selector) => [...document.querySelectorAll(selector)]);
    const hasOpenOverlay = () =>
      Boolean(
        document.querySelector(
          '.drawer.active, .menu-drawer-container[open], .header__search details[open], .mobile-facets__disclosure[open]'
        )
      );
    const syncFixedControls = () => {
      const overlayOpen = hasOpenOverlay();
      mobileNavigation?.toggleAttribute('inert', overlayOpen);
      mobileNavigation?.setAttribute('aria-hidden', overlayOpen ? 'true' : 'false');

      if (purchaseBar) {
        const purchaseBarAvailable = purchaseBar.classList.contains('is-visible') && !overlayOpen;
        purchaseBar.toggleAttribute('inert', !purchaseBarAvailable);
        purchaseBar.setAttribute('aria-hidden', purchaseBarAvailable ? 'false' : 'true');
      }
    };

    document.addEventListener('toggle', () => requestAnimationFrame(syncFixedControls), true);
    const overlayObserver = new MutationObserver(() => requestAnimationFrame(syncFixedControls));
    overlayElements.forEach((element) =>
      overlayObserver.observe(element, { attributes: true, attributeFilter: ['class', 'open'] })
    );
    syncFixedControls();

    const footerMenus = [...document.querySelectorAll('.footer__menu')];
    const desktopFooter = window.matchMedia('(min-width: 750px)');
    const syncFooterMenus = () => {
      footerMenus.forEach((menu) => {
        menu.open = desktopFooter.matches;
      });
    };
    desktopFooter.addEventListener('change', syncFooterMenus);
    syncFooterMenus();

    const cartLink = document.querySelector('.mobile-bottom-navigation__cart');
    cartLink?.addEventListener('click', (event) => {
      const cartDrawer = document.querySelector('cart-drawer');
      const headerCart = document.querySelector('#cart-icon-bubble');
      if (!cartDrawer || !headerCart) return;
      event.preventDefault();
      headerCart.click();
    });

    const syncCartCount = () => {
      const source = document.querySelector('#cart-icon-bubble .cart-count-bubble [aria-hidden="true"]');
      const target = document.querySelector('[data-mobile-cart-count]');
      const accessibleTarget = document.querySelector('[data-mobile-cart-count-a11y]');
      if (!target) return;
      const count = source?.textContent?.trim() || '0';
      target.textContent = count;
      target.classList.toggle('is-empty', count === '0');
      if (accessibleTarget) accessibleTarget.textContent = `${count} ${count === '1' ? 'item' : 'items'}`;
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => requestAnimationFrame(syncCartCount));
    }

    const purchaseButton = purchaseBar?.querySelector('[data-mobile-purchase-button]');
    const purchasePrice = purchaseBar?.querySelector('[data-mobile-purchase-price]');
    const productInfo = document.querySelector('product-info');

    if (!purchaseBar || !purchaseButton || !productInfo) return;

    const getProductButton = () => productInfo.querySelector('.product-form__submit');
    const syncPurchaseBar = () => {
      const productButton = getProductButton();
      if (!productButton) return;
      purchaseButton.disabled = productButton.disabled;
      const label = productButton.querySelector('span')?.textContent?.trim();
      if (label) purchaseButton.textContent = label;
      const priceContainer = productInfo.querySelector('.product__info-container [id^="price-"]');
      const price =
        priceContainer?.querySelector('.price--on-sale .price__sale .price-item--sale') ||
        priceContainer?.querySelector('.price__regular .price-item--regular');
      if (price && purchasePrice) purchasePrice.textContent = price.textContent.trim();
    };

    purchaseButton.addEventListener('click', () => getProductButton()?.click());
    syncPurchaseBar();

    const productButton = getProductButton();
    if (productButton) {
      let productButtonHasBeenVisible = false;
      const visibilityObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) productButtonHasBeenVisible = true;
          const show = productButtonHasBeenVisible && !entry.isIntersecting && entry.boundingClientRect.top < 0;
          purchaseBar.classList.toggle('is-visible', show);
          syncFixedControls();
        },
        { threshold: 0.15 }
      );
      visibilityObserver.observe(productButton);
    }

    const productObserver = new MutationObserver(() => requestAnimationFrame(syncPurchaseBar));
    productObserver.observe(productInfo, { attributes: true, childList: true, subtree: true });
  });
})();
